export default __webpack_public_path__ + "static/media/EC.6e35cfe7.png";